// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CoverPage_wrapper__23A35","title":"CoverPage_title__1t3ba","subtitle":"CoverPage_subtitle__LxG6N"};